import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import MpciApiClient from '../Common/services/MpciApiClient'

const VesselMasterService = {
    create: (data, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.VESSEL_MASTER_POST,
      data,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

  update: (data, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'PUT',
      UaeMpciApiUrls.VESSEL_MASTER_PUT,
      data,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

    delete: (id, onSuccess, onError) => {
    MpciApiClient.del(
      `${UaeMpciApiUrls.VESSEL_MASTER_DELETE}/${id}`,
      {},
      onSuccess,
      onError
    )
  },

    getById: (id, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.VESSEL_MASTER_GET,
      { id },
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

  checkImo: (imoNumber, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'GET',
      `${UaeMpciApiUrls.VESSEL_MASTER_CHECK_IMO}?imoNumber=${imoNumber}`,
      null,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

    clone: (id, onSuccess, onError) => {
    MpciApiClient.post(
      `${UaeMpciApiUrls.VESSEL_MASTER_CLONE}/${id}`,
      {},
      onSuccess,
      onError
    )
  }
}

export default VesselMasterService
